import { Button, DialogActions, DialogContent, Divider } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Form, Formik } from "formik";
import * as yup from "yup";
import LabelsContext from "../../../../../../lang/LabelsContext";
import AuthorService, { AuthorServiceType } from "../AuthorService";
import UserService, { UserServiceType } from "../../../../../../service/user/UserService";
import useStyles from "./AuthorsModalStyle";

export default function AuthorsModal(props: any) {
  const { authorsProp, authorSave, setArticle, article, setOpen } = props;

  const { countryList }: UserServiceType = UserService();
  const {
    closeModal,
    selectedAddedListAuthor,
    setSelectedAddedListAuthor,
    setSelectedSearchListAuthor,
  }: AuthorServiceType = AuthorService({ article });
  const { Labels } = LabelsContext();
  const classes = useStyles();

  const validationSchema = yup.object().shape({
    firstName: yup.string().required(Labels.FIRSTNAME_REQUIRED),
    lastName: yup.string().required(Labels.LASTNAME_REQUIRED),
    email: yup.string().required(Labels.EMAIL_REQUIRED).email(),
  });
  return (
    <DialogContent>
      <Divider />
      {authorsProp && countryList && (
        <Formik
          validationSchema={validationSchema}
          onSubmit={(values) => {
            closeModal();
            setSelectedSearchListAuthor(undefined);
            setSelectedAddedListAuthor(undefined);
          }}
          initialValues={authorsProp}
        >
          {({ handleBlur, values, touched, errors, handleChange, setFieldValue }) => (
            <Form>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    id="firstName"
                    name="firstName"
                    label={Labels.FIRSTNAME}
                    value={values?.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.firstName && Boolean(errors.firstName)}
                    helperText={touched.firstName && errors.firstName}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    id="middleName"
                    name="middleName"
                    label={Labels.MIDDLENAME}
                    value={values?.middleName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.middleName && Boolean(errors.middleName)}
                    helperText={touched.middleName && errors.middleName}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    id="lastName"
                    name="lastName"
                    label={Labels.LASTNAME}
                    value={values?.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched?.lastName && Boolean(errors?.lastName)}
                    helperText={touched?.lastName && errors?.lastName}
                    fullWidth
                    required
                  />
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    id="department"
                    name="department"
                    label={Labels.DEPARTMENT}
                    value={values?.department}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched?.department && Boolean(errors?.department)}
                    helperText={touched?.department && errors?.department}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    id="institute"
                    name="institute"
                    label={Labels.INSTITUTE}
                    value={values?.institute}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched?.institute && Boolean(errors?.institute)}
                    helperText={touched?.institute && errors?.institute}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Autocomplete
                    options={countryList}
                    value={countryList[0]}
                    onChange={(event, newValue) => {
                      setFieldValue("country", newValue.countryName);
                    }}
                    getOptionLabel={(option: any) => option.countryName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="normal"
                        id="country"
                        name="country"
                        onBlur={handleBlur}
                        label={Labels.COUNTRY}
                        error={touched.institute && Boolean(errors.institute)}
                        helperText={touched.institute && errors.institute}
                        fullWidth
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    id="orcid"
                    name="orcid"
                    label={Labels.ORCID}
                    value={values?.orcid}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched?.orcid && Boolean(errors?.orcid)}
                    helperText={touched?.orcid && errors?.orcid}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    id="city"
                    name="city"
                    label={Labels.CITY}
                    value={values?.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched?.city && Boolean(errors?.city)}
                    helperText={touched?.city && errors?.city}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    id="email"
                    name="email"
                    value={values?.email}
                    autoComplete="new-password"
                    label={Labels.EMAIL}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched?.email && Boolean(errors?.email)}
                    helperText={touched?.email && errors?.email}
                    fullWidth
                    required
                  />
                </Grid>
              </Grid>

              {selectedAddedListAuthor && (
                <Button variant="contained" color="primary" className={classes.button} type="submit">
                  {Labels.SAVE}
                </Button>
              )}
              <DialogActions>
                <Button
                  onClick={() => {
                    setSelectedSearchListAuthor(undefined);
                    setSelectedAddedListAuthor(undefined);
                    setOpen(false);
                  }}
                  color="primary"
                >
                  {Labels.CANCEL}
                </Button>
                <Button
                  color="primary"
                  onClick={() => {
                    setSelectedSearchListAuthor(undefined);
                    setSelectedAddedListAuthor(undefined);
                    authorSave(values, setArticle);
                  }}
                >
                  {Labels.ADD}
                </Button>
                {/* {selectedAddedListAuthor && (
          <Button
            color="primary"
            onClick={() => {
              addAuthor(selectedAddedListAuthor);
            }}
          >
            {Labels.UPDATE}
          </Button>
        )} */}
              </DialogActions>
            </Form>
          )}
        </Formik>
      )}
    </DialogContent>
  );
}
